<template>
  <div class="personalIndex xi">
    <nh-com></nh-com>
    <div class="personal-content">
      <div class="personal-box clearfix">
        <div class="personal-left">
          <hd-img :active="9"></hd-img>
        </div>
        <div class="personal-right" v-if="personalData != null && Object.keys(personalData).length != 0">
          <div class="addhospital">
            <el-form :model="personalData" :rules="rules" ref="personalData" label-width="100px">
              <!-- <el-scrollbar class="left-nav-wrap" style="height: calc(100vh - 120px)"> -->
              <div class="form-box">
                <div style="background-color: #f5f7fa; padding: 5px 10px; margin-bottom: 30px">基本信息</div>
                <div class="formContent flex-space-between" style="align-items: start">
                  <div class="" style="width: 70%">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="用户编号">
                          <el-input v-model="personalData.userNumber" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="工号">
                          <el-input v-model="personalData.doctorNo" disabled></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="姓名" prop="userName">
                          <el-input v-model="personalData.userName" autocomplete="off" :disabled="isReadonly"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="昵称">
                          <el-input v-model="personalData.nickName" autocomplete="off" :disabled="isReadonly"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="电话(账号)" prop="phone">
                          <el-input v-model="personalData.phone" autocomplete="off" disabled> </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="性别" prop="sex">
                          <el-select v-model="personalData.sex" style="width: 100%" placeholder="性别" :disabled="isReadonly">
                            <el-option label="男" :value="1"></el-option>
                            <el-option label="女" :value="0"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="生日">
                          <el-date-picker v-model="personalData.birthday" style="width: 100%" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" :disabled="isReadonly"> </el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="学历">
                          <el-select v-model="personalData.userQualificationId" style="width: 100%" clearable placeholder="请选择用户学历" :disabled="isReadonly">
                            <el-option v-for="item in UserQualificationData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item label="联系地址" prop="regionId">
                          <el-cascader
                            :placeholder="personalData.region ? personalData.region.fullName : '请选择所在区域'"
                            v-model="personalData.regionId"
                            :options="RegionData"
                            size="medium"
                            :props="{
                              emitPath: false,
                              multiple: false,
                              checkStrictly: true,
                              lazy: true,
                              lazyLoad: LasyLoadRegion,
                              value: 'id',
                              label: 'regionName',
                              children: 'childrens',
                            }"
                            style="margin-right: 10px; width: 100%"
                            :disabled="isReadonly"
                          >
                          </el-cascader>
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item label="详细地址" prop="address">
                          <el-input v-model="personalData.address" placeholder="请输入详细地址" :disabled="isReadonly"> </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div style="background-color: #f5f7fa; padding: 5px 10px; margin-bottom: 30px">所属机构信息</div>
                <div class="formContent" style="width: 90%">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="所属机构">
                        <el-input v-model="personalData.organization.name" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="职位">
                        <el-input v-model="personalData.userPost.userPostName" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="所属部门">
                        <el-input v-model="personalData.department.name" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="科室" v-if="ClientId == YunClient || ClientId == AssociationClient || ClientId == FairClient">
                        <el-input v-model="personalData.hospitalDeptName" disabled></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="ClientId == YunClient">
                      <el-form-item label="签约医生类型" prop="doctorHealthManagerType">
                        <el-select v-model="personalData.doctorHealthManagerType" style="width: 100%" placeholder="请选择签约医生类型" disabled>
                          <el-option label="医生" :value="0"> </el-option>
                          <el-option label="健管师" :value="1"> </el-option>
                          <el-option label="药师" :value="2"> </el-option>
                          <el-option label="护师" :value="3"> </el-option>
                          <el-option label="技师" :value="4"> </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="是否是专家" v-if="ClientId == YunClient || ClientId == FairClient">
                        <el-switch v-model="personalData.userCategoryType" :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#999999" disabled> </el-switch>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
                <div style="background-color: #f5f7fa; padding: 5px 10px; margin-bottom: 30px">业务信息</div>
                <div class="formContent" style="width: 90%">
                  <el-row>
                    <el-col :span="12" v-if="ClientId == YunClient || ClientId == AssociationClient || ClientId == FairClient">
                      <el-form-item label="证书编号">
                        <el-input v-model="personalData.certificateNumber" placeholder="证书编号" :disabled="isReadonly"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="职称" prop="userTitleId" v-if="ClientId == YunClient || ClientId == TotalClient || ClientId == AssociationClient || ClientId == FairClient">
                        <el-cascader
                          :options="userTitleData"
                          :props="{
                            expandTrigger: 'hover',
                            emitPath: false,
                            value: 'id',
                            label: 'userTitleName',
                            children: 'children',
                          }"
                          v-model="personalData.userTitleId"
                          style="width: 100%"
                          clearable
                          :disabled="isReadonly"
                        ></el-cascader>
                      </el-form-item>
                      <el-form-item label="职称" v-else>
                        <el-cascader
                          :options="userTitleData"
                          :props="{
                            expandTrigger: 'hover',
                            emitPath: false,
                            value: 'id',
                            label: 'userTitleName',
                            children: 'children',
                          }"
                          v-model="personalData.userTitleId"
                          style="width: 100%"
                          clearable
                          :disabled="isReadonly"
                        ></el-cascader>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="ClientId == YunClient || ClientId == AssociationClient || ClientId == FairClient">
                      <el-form-item label="学术职称">
                        <el-select v-model="personalData.academicTitle" style="width: 100%" clearable placeholder="请选择学术职称" :disabled="isReadonly">
                          <el-option v-for="item in academicTitleData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="简介">
                        <el-input type="textarea" v-model="personalData.profile" placeholder="请输入简介" :disabled="isReadonly"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="ClientId == YunClient || ClientId == AssociationClient || ClientId == FairClient">
                      <el-form-item label="擅长">
                        <el-input type="textarea" v-model="personalData.expertise" placeholder="请输入擅长" :disabled="isReadonly"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="个人介绍">
                        <!-- <quill-editor v-model="personalData.abstract" /> -->
                        <!-- <VueTinymce v-model="personalData.abstract" ref="richTextEditor" :setting="setting" /> -->
                        <p v-html="personalData.abstract" v-if="isReadonly"></p>
                        <Editor api-key="no-api-key" :init="setting" v-model="personalData.abstract" v-else />
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="ClientId == YunClient || ClientId == AssociationClient || ClientId == FairClient">
                      <el-form-item label="资质证书">
                        <div class="flex-start" v-if="imgList.length > 0">
                          <div v-for="(img, i) in imgList" :key="i" style="margin-right: 10px;">
                            <el-image hide-on-click-modal :src="`${CommonPath}${img}`" preview-teleported :zoom-rate="1.2" :preview-src-list="[`${CommonPath}${img}`]" style="width: 50px; height: 50px"></el-image>
                          </div>
                          
                        </div>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="ClientId == YunClient || ClientId == AssociationClient || ClientId == FairClient">
                      <el-form-item label="身份证正面">
                        <el-image hide-on-click-modal preview-teleported :zoom-rate="1.2" :preview-src-list="[`${CommonPath}${personalData.idCardFront}`]" v-if="personalData.idCardFront" :src="`${CommonPath}${personalData.idCardFront}`" style="width: 50px; height: 50px" fit="contain" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="ClientId == YunClient || ClientId == AssociationClient || ClientId == FairClient">
                      <el-form-item label="身份证反面">
                        <el-image hide-on-click-modal preview-teleported :zoom-rate="1.2" :preview-src-list="[`${CommonPath}${personalData.idCardBack}`]" v-if="personalData.idCardBack" :src="`${CommonPath}${personalData.idCardBack}`" style="width: 50px; height: 50px" fit="contain" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
                <el-form-item v-if="!isSave">
                  <el-button type="primary" @click="onEdit">编辑</el-button>
                </el-form-item>
                <el-form-item v-if="isSave">
                  <el-button type="primary" @click="onSubmit('personalData')">保存</el-button>
                  <el-button type="primary" @click="onCancel">取消编辑</el-button>
                </el-form-item>
              </div>
              <!-- </el-scrollbar> -->
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <ft-com></ft-com>
  </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import tinymce from "tinymce/tinymce";
import axios from "axios";
import ftCom from "../../components/footer";
import nhCom from "../../components/navheader";
import hdImg from "../../components/headerImg";
import { getUserInfo, userInfoLoad } from "../../utils/userInfo";
import { UserPost } from "../../components/User/UserPost";
import { UserTitle } from "../../components/User/UserTitle";
import { UserInfo } from "../../components/User/UserInfo";
import { UserQualification } from "../../components/User/UserQualification";
import { shoppingMall } from "../../components/shoppingMall/shoppingMall";
import storage from "../../utils/customstorage";
tinymce.init({});
export default {
  name: "personalIndex",
  inject: ["reload"],
  components: {
    ftCom,
    nhCom,
    hdImg,
    Editor,
  },
  computed: {
    headers() {
      return {
        Authorization: "Bearer" + " " + storage.getItem("token"),
      };
    },
  },
  data() {
    var post = new UserPost(this.TokenClient, this.Services.Authorization);
    var title = new UserTitle(this.TokenClient, this.Services.Authorization);
    var user = new UserInfo(this.TokenClient, this.Services.Authorization);
    var region = new shoppingMall(this.TokenClient, this.Services.Authorization);
    var userQualification = new UserQualification(this.TokenClient, this.Services.Authorization);
    return {
      UserQualification: userQualification,
      Region: region,
      labelPosition: "top",
      personalData: {},
      isSave: false,
      isReadonly: true,
      titleOptions: [], //职称
      postOptions: [], //职位
      postDomain: post,
      titleDomain: title,
      userDomain: user,
      photo: getUserInfo().photo,
      categoryId: getUserInfo().categoryId,
      organizationId: getUserInfo().organizationId,
      RegionData: [],
      UserQualificationData: [],
      userTitleData: [],
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      academicTitleData: [
        {
          id: 1,
          name: "助教",
        },
        {
          id: 2,
          name: "讲师",
        },
        {
          id: 3,
          name: "副教授",
        },
        {
          id: 4,
          name: "教授",
        },
      ],

      rules: {
        userName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/, message: "请输入合法手机号/电话号", trigger: "blur" },
        ],
        mailAddress: [
          // { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: "email", message: "请输入正确的邮箱地址", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入登录密码", trigger: "blur" },
          {
            pattern: /^(?![\s\u4e00-\u9fa5]+$).{6,16}$/,
            message: "密码为6~16个英文字母、数字、符号组成！",
            trigger: "blur",
          },
        ],
        confirmPwd: [{ required: true, message: "密码不能为空", trigger: "blur" }],
        birthday: [
          { required: true, message: "请选择时间", trigger: "blur" },
          { type: "date", message: "请选择时间", trigger: "blur" },
        ],
        departmentId: [{ required: true, message: "请选择所属部门", trigger: "blur" }],
        hospitalDeptId: [{ required: true, message: "请选择科室", trigger: "blur" }],
        regionId: [{ required: true, message: "请选择地区", trigger: "blur" }],
        sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
        userPostId: [{ required: true, message: "请选择用户职位", trigger: "blur" }],
        userTitleId: [{ required: true, message: "请选择用户职称", trigger: "blur" }],
        roleId: [{ required: true, message: "请选择用户角色", trigger: "blur" }],
        versionsId: [{ required: true, message: "请选择版本", trigger: "change" }],
        select: [{ required: true, message: "请选择版本时长", trigger: "change" }],
        money: [
          { pattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/, message: "小数点后保留两位", trigger: "blur" },
          { required: true, message: "请输入正确的金额", trigger: "blur" },
        ],
        mZRate: [{ required: true, message: "请输入比例", trigger: "blur" }],
        auditDiagnoseMoney: [{ required: true, message: "请输入处方审核价格", trigger: "blur" }],
        idCardFront: [{ required: true, message: "请上传图片", trigger: "change" }],
        idCardBack: [{ required: true, message: "请上传图片", trigger: "change" }],
      },
      phonerules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/, message: "请输入合法手机号/电话号", trigger: "blur" },
        ],
      },
      setting: {
        menubar: false,
        cleanup: true,
        toolbar: "undo redo | fullscreen | formatselect alignleft aligncenter alignright alignjustify | link unlink | numlist bullist | image table | fontselect fontsizeselect forecolor backcolor | bold italic underline strikethrough | indent outdent | superscript subscript | removeformat |",
        toolbar_drawer: "sliding",
        quickbars_selection_toolbar: "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
        plugins: "link image media table lists fullscreen quickbars autoresize",
        language: "zh_CN",
        // >>> 核心修复：设置基础路径并指定皮肤 <<<
        base_url: "/tinymce", // 指向 public/tinymce 目录
        skin_url: "/tinymce/skins/ui/oxide",
        // <<< 核心修复结束 <<<
        auto_focus_urls: false,
        max_height: 600,
        min_height: 350,
        images_upload_handler: (blobInfo, success, failure) => {
          let formdata = new FormData();
          // formdata.set('file', blobInfo.blob())
          // 二进制文件，文件名装入form传到后台处理
          formdata.append("file", blobInfo.blob(), blobInfo.filename());
          axios({
            method: "POST",
            headers: { "Content-Type": "multipart/form-data", Authorization: "Bearer" + " " + JSON.parse(sessionStorage.getItem(this.ClientId + "Token")).access_token },
            // 这里是你的上传地址
            url: this.CommonFilePath,
            data: formdata,
          }).then((res) => {
            if (res.data[0].isSuccess == true) {
              // 这里返回的是你图片的地址
              success(this.CommonPath + res.data[0].completeFilePath);
            } else {
              failure("图片上传失败!");
            }
          });
        },
      },
      fileUploadUrl: this.CommonFilePath,
      imgList: [],
    };
  },
  mounted() {
    this.LoadUserInfo();
    this.InitialUserQualification();
    this.InitialUserTitle();
  },
  methods: {
    handleSuccess(response, file, fileList) {
      var _this = this;
      response.forEach(function (file) {
        _this.AddUserData.photoFile = file.completeFilePath;
      });
    },
    InitialUserTitle() {
      var _this = this;
      _this.titleDomain.GetUserTitle(
        this.userInfo.productId,
        function (data) {
          _this.userTitleData = data.data;
          // 递归children:[]----children:null
          const mapTree = (item) => {
            const haveChildren = Array.isArray(item.children) && item.children.length > 0;
            return {
              ...item,
              children: haveChildren ? item.children.map((child) => mapTree(child)) : null,
            };
          };
          _this.userTitleData = _this.userTitleData.map((item) => mapTree(item));
        },
        function (err) {
          console.log(err);
        }
      );
    },
    onEdit() {
      this.isSave = true;
      this.isReadonly = false;
      this.InitialRegion();
    },
    InitialUserQualification() {
      var _this = this;
      _this.UserQualification.Qualifications(
        function (data) {
          _this.UserQualificationData = data.data;
        },
        function (err) {
          console.log(err);
        }
      );
    },
    InitialRegion() {
      var _this = this;
      _this.Region.Regions(
        null,
        function (data) {
          _this.RegionData = data.data;
        },
        function (err) {
          console.log(err);
        }
      );
    },
    LasyLoadRegion(node, resolve) {
      var _this = this;
      _this.Region.Regions(
        node.value,
        function (data) {
          for (var dataIndex = 0; dataIndex < data.data.length; dataIndex++) {
            data.data[dataIndex].leaf = data.data[dataIndex].regionLevel >= 3;
          }
          resolve(data.data);
        },
        function (err) {
          resolve([]);
        }
      );
    },
    LoadUserInfo() {
      var _this = this;
      _this.userDomain.UserMes(
        function (data) {
          _this.personalData = data.data;
          _this.personalData.academicTitle = _this.personalData.academicTitle ? _this.personalData.academicTitle : null;
          _this.imgList = _this.personalData.certificateImage.split(",");
          _this.imgList.forEach((item) => {
            let str = `${_this.CommonPath}${item}`;
            item = str;
            console.log(item);
          });
          console.log(_this.imgList);
        },
        function (error) {
          _this.$router.push({
            path: "/Login",
            query: {},
          });
        }
      );
    },
    onSubmit(formName) {
      var _this = this;
      var editeItem = this.personalData;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          this.userDomain.Edit(
            editeItem,
            function (data) {
              _this.$message({
                type: "success",
                message: "操作成功!",
              });
              userInfoLoad(editeItem.userName, editeItem.phone, editeItem.userTitleId, editeItem.userPostId, editeItem.telephone, editeItem.address, editeItem.profile, null);
              _this.reload();
            },
            function (error) {
              console.log(error);
              _this.$message.error("系统出错!保存信息失败。");
            }
          );
        }else {
          return false;
        }
      });
      console.log(editeItem);
    },
    onCancel() {
      this.isSave = false;
      this.isReadonly = true;
    },
    init() {
      var _this = this;
      //职称
      _this.titleDomain.Titles(
        function (data) {
          _this.titleOptions = data.data;
        },
        function (error) {
          console.log(error);
        }
      );
      //职务
      _this.postDomain.Posts(
        _this.organizationId,
        function (data) {
          _this.postOptions = data.data;
        },
        function (error) {
          console.log(error);
        }
      );
    },
    onEditorChange({ editor, html, text }) {
      this.content = html;
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/footer.css";

.banner {
  width: 100%;
  height: 160px;
  background: url("../../assets/img/news_banner.jpg") center no-repeat;
}

.banner-wrap {
  position: relative;
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

.banner-text {
  float: left;
}

.banner-text h3 {
  padding-top: 35px;
  font-size: 26px;
  font-weight: normal;
  color: #ffffff;
}

.banner-text p {
  font-size: 14px;
  color: #ffffff;
  margin-top: 20px;
}

.banner-text p a {
  color: #ffffff;
  font-size: 14px;
  margin: 0 5px;
}
/**/
.personal-content {
  background: #f7f7f7;
  padding: 40px 0;
}
.personal-box {
  width: 1200px;
  margin: 0 auto;
}
.personal-left {
  float: left;
}

.personal-right {
  float: right;
  width: 985px;
  padding: 20px 30px;
  background: #ffffff;
  box-sizing: border-box;
}
.content {
  background: #fff;
  border-radius: 8px;
  padding: 20px 15px;
  min-height: 640px;
}
.line-title {
  width: 3px;
  height: 16px;
  background: #333;
  margin-right: 5px;
}
.pageTitle {
  font-size: 16px;
  color: #333333;
  font-weight: bold;
}
.el-form-tit {
  margin-top: 10px;
  margin-bottom: 20px;
}
.el-form-tit .iconfont {
  color: #04a290;
  font-size: 24px;
  margin-right: 5px;
}
.el-form-tit span {
  display: inline-block;
  font-size: 24px;
  font-weight: 700;
  color: #333333;
}
.el-form-tit span em {
  font-style: normal;
  color: #04a290;
}
</style>
<style scoped>
.el-page-header {
  line-height: 73px;
  padding-left: 20px;
}

/**/
.addhospital {
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.addhospital .el-form {
  flex: 1;
}

.addhospital .form-box {
  /* padding: 30px 50px 30px 30px; */
  background: #ffffff;
  border-radius: 10px;
  overflow: hidden;
}

.demo-drawer__footer {
  display: flex;
  margin-left: 100px;
}

.el-drawer /deep/ .el-drawer {
  width: 100vw;
  background-color: #eff7f8;
}

.headImg {
  position: relative;
}

.headimgBox {
  width: 130px;
  height: 130px;
  border-radius: 50%;
  margin: 0 auto;
  overflow: hidden;
  border: 5px solid rgba(12, 154, 154, 0.28);
}

.headimgBox img {
  width: 100%;
}
.pay-top {
  position: relative;
}

.payItem {
  line-height: 2;
}

.payItem p {
  float: left;
}

.payItem span {
  float: right;
}

.payNum {
  color: red;
  font-size: 24px;
}

.avatar {
  width: auto;
  height: 146px;
}
</style>
